import React, { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getQueryString } from '../../../helpers/url';
import { WelletContext } from '../../../context/WelletContext';
import { useTranslation } from 'react-i18next';
import { InputSingleCharacter } from '../../../components/Common/InputSingleCharacter/InputSingleCharacter';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import Button from '../../../components/Common/Button/Button';
import ErrorBox from '../../../components/Common/ErrorBox/ErrorBox';
import { Spinner } from '../../../components/Common/Spinner/Spinner';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { exchangeToken } from '../../../actions/associatesActions';
import FixedButton from '../../../components/Common/FixedButton/FixedButton';

const LoginCode = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const tenantId = useSelector((state) => state.app.tenantId);
  const history = useHistory();
  const email = getQueryString('email');
  const welletContext = useContext(WelletContext);
  const auth = getAuth();
  const codeLength = 4;
  const [code, setCode] = useState('');
  const [errorCode, setErrorCode] = useState('');
  const [btnVerifyDisable, setBtnVerifyDisable] = useState(true);
  const [verifyingCode, setVerifyingCode] = useState(false);
  const [sendingCode, setSendingCode] = useState(false);
  const [secondsRemaining, setSecondsRemaining] = useState(0);

  const onVerifyHandle = (user) => {
    exchangeToken(dispatch, user, () => history.push('/'));
  };

  const handleChangeEmail = () => {
    history.push({
      pathname: '/sign-up',
    });
  };

  const requestCodeVerification = async () => {
    if (secondsRemaining > 0) {
      return;
    }
    setSendingCode(true);
    try {
      const result = await welletContext.apis.tickets.post(`/users/login-one-time`, {
        email: email,
        tenantId: tenantId,
      });
      startTimer();
      setSendingCode(false);
    } catch (error) {
      console.error(error);
      setSendingCode(false);
    }
  };

  const sendCodeVerification = async (code) => {
    setVerifyingCode(true);
    try {
      const result = await welletContext.apis.tickets.post(`/users/login-one-time/validate`, {
        email: email,
        tenantId: tenantId,
        code: code,
      });

      if (result.data.isValid) {
        if (result.data.sendCodeTrigger === 'LOGIN') {
          const userCredentials = await signInWithCustomToken(auth, result.data.customToken);
          onVerifyHandle(userCredentials.user);
        } else {
          history.push({
            pathname: '/sign-up',
            search: '?token=' + result.data.customToken + '&email=' + email,
          });
        }
      } else {
        setErrorCode(t('signUp.codeError'));
        setVerifyingCode(false);
      }
    } catch (error) {
      console.error(error);
      setVerifyingCode(false);
    }
  };

  const onCodeChange = (value) => {
    setCode(value);
    setErrorCode('');
  };

  const verifyCode = () => {
    sendCodeVerification(code);
  };

  const startTimer = () => {
    setSecondsRemaining(120);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (secondsRemaining > 0) {
        setSecondsRemaining(secondsRemaining - 1);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [secondsRemaining]);

  useEffect(() => {
    startTimer();
  }, []);

  useEffect(() => {
    if (code.length === codeLength) setBtnVerifyDisable(false);
    else setBtnVerifyDisable(true);
  }, [code]);

  return (
    <>
      <Header title={''} pathName={'/login-user'} hasBackground={true} />
      <ContentApp background={true}>
        <div className=''>
          <div className='font-medium fw-700 text-tertiary' style={{ lineHeight: '1.6rem' }}>
            {t('login.enterCode')}
          </div>
          <div className='mt-2 font-small text-secondary'>{t('login.enterCodeDescription')}:</div>
          <div className='font-small text-tertiary'>{email}</div>
          <div className='mt-4 pt-2 input-character'>
            <InputSingleCharacter
              length={codeLength}
              onValueChange={(result) => onCodeChange(result)}
            />
          </div>

          <FixedButton>
            <div className='mb-3'>{errorCode && <ErrorBox title={errorCode} />}</div>
            <Button
              className={`${verifyingCode ? 'loading' : ''} btn-primary`}
              onClick={verifyCode}
              size={'large'}
              fontSize={'18px'}
              disabled={btnVerifyDisable}
              text={
                verifyingCode ? (
                  <div className='d-flex justify-content-center'>
                    <Spinner size={25} color='#000' />
                  </div>
                ) : (
                  t('continue')
                )
              }
              icon={verifyingCode ? false : true}
              typeIcon='arrow'
              iconColor='#000'
            />
            <Button
              className={`mt-2 btn-primary`}
              size={'large'}
              fontSize={'18px'}
              onClick={requestCodeVerification}
              disabled={secondsRemaining > 0}
              text={
                sendingCode ? (
                  <div className='d-flex justify-content-center'>
                    <Spinner size={25} color='#000' />
                  </div>
                ) : (
                  <>
                    {secondsRemaining > 0
                      ? `${t('signUp.resendCode')} ${Math.floor(secondsRemaining / 60)}:${(
                          secondsRemaining % 60
                        )
                          .toString()
                          .padStart(2, '0')}`
                      : 'Reenviar código'}
                  </>
                )
              }
              type='button'
            />
            <div className='text-secondary text-center mt-3' onClick={() => handleChangeEmail()}>
              {t('login.useOtherEmail')}
            </div>
          </FixedButton>
        </div>
      </ContentApp>
    </>
  );
};
export default LoginCode;
